import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fromFilter, fromReservation } from 'store/selectors';

import { FilterList } from 'components';


const FilterListContainer = props => <FilterList {...props} />;

FilterListContainer.propTypes = {
  filter: PropTypes.string.isRequired,
  defaultFilter: PropTypes.string,
};

const mapStateToProps = (state, { filter, items }) => ({
  activeFilter: fromFilter.getFilter(state, filter),
  items: items.map(id => ({
    ...fromReservation.getGuest(state, id),
    canBeAdded: fromReservation.canGuestBeAddedToActiveCabin(state, id),
  })),
});

export default connect(mapStateToProps)(FilterListContainer);



// WEBPACK FOOTER //
// ./src/containers/FilterList.js